import { render } from "./MsThOptionBoolean.vue?vue&type=template&id=5b66071a"
import script from "./MsThOptionBoolean.vue?vue&type=script&lang=js"
export * from "./MsThOptionBoolean.vue?vue&type=script&lang=js"

import "./MsThOptionBoolean.vue?vue&type=style&index=0&id=5b66071a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__